export const meetRoute = [{
  path: 'meet',
  component: () => import('../../../components/router-view'),
  children: [
    {
      path: '',
      name: 'Meets',
      component: () => import('../../../components/Admin/Meets'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'create',
      name: 'CreateMeet',
      component: () => import('../../../components/Admin/Meets/create'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: 'view/:id/:password',
      name: 'viewMeet',
      component: () => import('../../../components/Admin/Meets/view'),
      meta: {
        access: ['admin']
      }
    },
    {
      path: ':id',
      name: 'EditMeet',
      component: () => import('../../../components/Admin/Meets/edit'),
      meta: {
        access: ['admin']
      }
    }
  ]
}]



// WEBPACK FOOTER //
// /src/router/admin/module/meet.js